package example.shadcn_kotlin.ui.pages.docs.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.TableDemo

@Page
@Composable
fun TablePage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/table.md", mapOf("title" to listOf("Table"), "description" to listOf("A responsive table component.")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import react.FC
import react.Props
import shadcn.ui.components.*
import web.cssom.ClassName

data class Invoices(
    val invoice: String,
    val paymentStatus: String,
    val totalAmount: String,
    val paymentMethod: String,
)

val invoices = listOf(
    Invoices(
        invoice = "INV001",
        paymentStatus = "Paid",
        totalAmount = "$250.00",
        paymentMethod = "Credit Card",
    ),
    Invoices(
        invoice = "INV002",
        paymentStatus = "Pending",
        totalAmount = "$150.00",
        paymentMethod = "PayPal",
    ),
    Invoices(
        invoice = "INV003",
        paymentStatus = "Unpaid",
        totalAmount = "$350.00",
        paymentMethod = "Bank Transfer",
    ),
    Invoices(
        invoice = "INV004",
        paymentStatus = "Paid",
        totalAmount = "$450.00",
        paymentMethod = "Credit Card",
    ),
    Invoices(
        invoice = "INV005",
        paymentStatus = "Paid",
        totalAmount = "$550.00",
        paymentMethod = "PayPal",
    ),
    Invoices(
        invoice = "INV006",
        paymentStatus = "Pending",
        totalAmount = "$200.00",
        paymentMethod = "Bank Transfer",
    ),
    Invoices(
        invoice = "INV007",
        paymentStatus = "Unpaid",
        totalAmount = "$300.00",
        paymentMethod = "Credit Card",
    ),
)
val TableDemo = FC<Props> {
    Table {
        TableCaption { + "A list of your recent invoices ."}
        TableHeader {
            TableRow {
                TableHead {
                    className = ClassName("w-[100px]")
                    +"Invoice"
                }
                TableHead { +"Status" }
                TableHead { +"Method" }
                TableHead {
                    className = ClassName("text-right")
                    +"Amount"
                }
            }
        }
        TableBody {
            invoices.forEach {
                TableRow {
                    key = it.invoice
                    TableCell {
                        className = ClassName("font-medium")
                        + it.invoice
                    }
                    TableCell { + it.paymentStatus }
                    TableCell { + it.paymentMethod }
                    TableCell {
                        className = ClassName("text-right")
                        + it.totalAmount
                    }
                }
            }
        }
    }
}"""){ 
 TableDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.Table
import shadcn.ui.components.TableBody
import shadcn.ui.components.TableCaption
import shadcn.ui.components.TableCell
import shadcn.ui.components.TableHead
import shadcn.ui.components.TableHeader
import shadcn.ui.components.TableRow
""", lang= "kotlin", highlight= "")
            CodeBlock("""Table {
    TableCaption { + "A list of your recent invoices ."}
    TableHeader {
        TableRow {
            TableHead {
                className = ClassName("w-[100px]")
                    +"Invoice"
            }
            TableHead { +"Status" }
            TableHead { +"Method" }
            TableHead {
                className = ClassName("text-right")
                    +"Amount"
            }
        }
    }
    TableBody {
            TableRow {
                TableCell {
                    className = ClassName("font-medium")
                    + "INV001"
                }
                TableCell { +"Paid" }
                TableCell { +"Credit Card" }
                TableCell {
                    className = ClassName("text-right")
                    + "${'$'}250"
                }
            }
    }
}
""", lang= "kotlin", highlight= "")
        }
    }
}
